import React, {useState} from "react"

import {FieldTableCellProps} from "../../../../../../render/table/table-cell"
import {isBulkSelection} from "../../../../../../../gd/right-click-menu"
import FieldProjectStatus_TableCellCalculated_Hovered from "./hovered"
import FieldProjectStatus_TableCellCalculated_NotHovered from "./not-hovered"
import {SystemStatus} from "../../../../../../../gd/const/system-status"
import ProjectStatusManager from "../../../../../../../gd/manager/project-status-manager"

// const debug = "FieldProjectStatus_TableCellCalculated"
const debug = false

export default function FieldProjectStatus_TableCellCalculated(props: FieldTableCellProps) {

    const [isHovered, setIsHovered]     = useState(false)
    const [showPopover, setShowPopover] = useState(false)
    
    let isEditable: boolean = !props.manager.isReadOnly && props.field.canEdit(props.listItem.item)
    
    const onMouseEnter = () => {
        if (!isEditable) {
            return
        }
        setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (showPopover) {
            return
        }
        
        setIsHovered(false)
    }

    const onValueChange = (value: ID | SystemStatus, shouldHidePopover: boolean = true) => {
        if (props.listItem.project.isSystemStatusType) {
            props.listItem.project.updateSystemStatus(value as SystemStatus)
        } else {
            props.listItem.project.updateStatus(value as ID)
        }

        shouldHidePopover && hidePopover()
    }

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        if (!isEditable) {
            return
        }

        setShowPopover(true)
    }

    const hidePopover = () => {
        setShowPopover(false)
        setIsHovered(false)
    }

    let status = null

    switch (props.listItem.project.systemType) {
        case gd.const.project.type.PROJECT      :
        case gd.const.project.type.BACKLOG      :
        case gd.const.project.type.SPRINT       :
            status = gd.session.statuses.get(props.listItem.project.statusId)
            break

        case gd.const.project.type.TAG          :
        case gd.const.project.type.WORKFOLDER   :
            /*don nothing*/
            break
    }

    if (!status) {
        const defaultStatuses = ProjectStatusManager.getDefaultStatuses(props.listItem.project.systemType)
        status =_.find(defaultStatuses, ps=>ps.id === props.listItem.project.systemStatus)
    }
    
    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return (
            <FieldProjectStatus_TableCellCalculated_Hovered
                className       = {props.className}
                style           = {style}
                status          = {status}
                listItem        = {props.listItem}
                showPopover     = {showPopover}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
                onClick         = {onClick}
                onValueChange   = {onValueChange}
                onHidePopover   = {hidePopover}
            />
        )
    } else {
        return (
            <FieldProjectStatus_TableCellCalculated_NotHovered
                className       = {props.className}
                style           = {style}
                status          = {status}
                listItem        = {props.listItem}
                column          = {props.column}
                field           = {props.field}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
